import type { OrderBaseParameters } from '../interfaces/order';

export const ORDER_BASE_PARAMETERS_KEYS = [
  'hasSafeParking',
  'isDedicated',
  'hasEcmr',
  'isExpress',
  'driverLanguages',
  'isExclusive',
  'sentNotificationNumber',
  'hasDoubleCrew',
  'hasDoubleDeck',
  'hasPalletExchange',
  'requiresDidb',
  'fuelTypes',
  'minEmissionStandard',
  'otherDriverPermissions',
] as const satisfies (keyof OrderBaseParameters)[];
